<template>
  <div class="stars">
    <svg
      v-for="index in total"
      :key="index"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enable-background="new 0 0 500 500"
      class="star"
    >
      <path
        d="M498.6,191.5c-3.9-12-15-20-27.6-20H323.3L277.6,31c-3.9-11.9-15-20-27.6-20c-12.6,0-23.7,8.1-27.6,20l-45.6,140.4H29c-12.6,0-23.7,8.1-27.6,20c-3.9,12,0.4,25.1,10.6,32.5l119.5,86.7L85.8,451c-3.9,11.9,0.4,25.1,10.6,32.4c10.2,7.4,24,7.4,34.1,0L250,396.7l119.5,86.8c5.1,3.7,11.1,5.6,17.1,5.6c6,0,12-1.9,17.1-5.6c10.2-7.4,14.4-20.5,10.6-32.4l-45.6-140.4L488,223.9C498.2,216.5,502.5,203.4,498.6,191.5z"
        class="star__shadow"
      />
      <g>
        <defs>
          <path
            :id="`${_uid}-star-path-${index}`"
            d="M498.6,191.5c-3.9-12-15-20-27.6-20H323.3L277.6,31c-3.9-11.9-15-20-27.6-20c-12.6,0-23.7,8.1-27.6,20l-45.6,140.4H29c-12.6,0-23.7,8.1-27.6,20c-3.9,12,0.4,25.1,10.6,32.5l119.5,86.7L85.8,451c-3.9,11.9,0.4,25.1,10.6,32.4c10.2,7.4,24,7.4,34.1,0L250,396.7l119.5,86.8c5.1,3.7,11.1,5.6,17.1,5.6c6,0,12-1.9,17.1-5.6c10.2-7.4,14.4-20.5,10.6-32.4l-45.6-140.4L488,223.9C498.2,216.5,502.5,203.4,498.6,191.5z"
          />
        </defs>
        <clipPath :id="`${_uid}-star-clip-${index}`">
          <use :xlink:href="`#${_uid}-star-path-${index}`" overflow="visible" />
        </clipPath>
        <rect
          x="0"
          :clip-path="`url(#${_uid}-star-clip-${index})`"
          :width="getWidth(index)"
          height="500"
          class="star__fill"
        />
      </g>
    </svg>
  </div>
</template>

<script>
const fullWidthOfInsideStar = 500

export default {
  name: 'Stars',
  props: {
    value: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      default: 5,
    },
  },
  methods: {
    getWidth(index) {
      if (this.value > index) {
        return fullWidthOfInsideStar
      }

      const p = index - this.value
      return p > 1 ? 0 : fullWidthOfInsideStar - fullWidthOfInsideStar * p
    },
  },
}
</script>

<style lang="scss">
.stars {
  display: flex;
  align-items: center;
  margin: 0 rem(-2px);
}

.star {
  width: rem(12px);
  margin: 0 rem(3px);

  &__shadow {
    fill: var(--secondary-color-3);
  }

  &__fill {
    fill: var(--secondary-color);
  }
}
</style>
